import mainApi from "../../api/mainApi";
import { BlImportResponse } from "../../interfaces/bl-import/blImport.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";
import { donwloadDefaultFile } from "../../modules/bl-exports/helpers/downloadHelper";

const BLImportService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET
     */
    getBlImports: builder.query<
      BlImportResponse,
      {
        page: number;
        size: number;
        type_filter?: string;
        value_filter?: string;
        filter_days?: string;
        id_usuario?: string;
        descargados?: boolean;
      }
    >({
      queryFn: async ({
        page,
        size,
        type_filter,
        value_filter,
        filter_days,
        id_usuario,
        descargados,
      }) => {
        try {
          const { data } = await mainApi.get<BlImportResponse>(
            "bls-import/getBlImports",
            {
              params: {
                page,
                size,
                type_filter,
                value_filter,
                filter_days,
                id_usuario,
                descargados,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    downloadBlImport: builder.mutation<
      Blob,
      {
        fileName: string;
        id_bl: number;
        id_usuario: number;
      }
    >({
      queryFn: async ({ fileName, id_bl, id_usuario }) => {
        try {
          const { data } = await mainApi.get<Blob>("bls/descargarBlImp", {
            timeout: 120000,
            params: {
              fileName,
              id_bl,
              id_usuario,
            },
            responseType: "blob",
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    searchContainersImport: builder.query<
      { contenedores: string }[],
      {
        search: string;
      }
    >({
      queryFn: async ({ search }) => {
        try {
          const { data } = await mainApi.get<{ contenedores: string }[]>(
            "bls-import/searchContainers",
            {
              params: {
                search,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    downloadBlImportActa: builder.mutation<
      Blob,
      {
        id_bl: number;
        id_usuario: number;
      }
    >({
      queryFn: async ({ id_bl, id_usuario }) => {
        try {
          const { data } = await mainApi.get<Blob>("bls/descargarActaImp", {
            params: {
              id_bl,
              id_usuario,
            },
            responseType: "blob",
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST donwload XLSX bls import
     */
    donwloadXlxsBlsImport: builder.mutation<
      any,
      {
        page: number;
        size: number;
        type_filter?: string;
        value_filter?: string;
        filter_days?: string;
        id_usuario?: string;
        descargados?: boolean;
      }
    >({
      queryFn: async ({
        page,
        size,
        type_filter,
        value_filter,
        filter_days,
        id_usuario,
        descargados,
      }) => {
        try {
          const { data } = await mainApi.post(
            "bls-import/exportBlsImportExcel",
            {
              page,
              size,
              type_filter,
              value_filter,
              filter_days,
              id_usuario,
              descargados,
            },
            {
              responseType: "blob",
            }
          );
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST Upload document file BL Import
     */
    uploadBlImportDocument: builder.mutation<
      any,
      {
        id_bl: number;
        file: File;
        file_type: string;
      }
    >({
      queryFn: async ({ id_bl, file_type, file }) => {
        const formdata = new FormData();
        formdata.append("file", file);
        try {
          const { data } = await mainApi.post(
            `bls-import/${id_bl}/upload`,
            formdata,
            {
              params: {
                file_type,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     *
     */
    uploadEcasFile: builder.mutation<
      any,
      {
        file: File;
        id_bl: string;
        id_usuario: string;
      }
    >({
      queryFn: async ({ id_bl, id_usuario, file }) => {
        try {
          const formData = new FormData();
          formData.append("id_bl", id_bl);
          formData.append("id_usuario", id_usuario);
          formData.append("ecas", file);
          const { data } = await mainApi.post(
            "/bls-import/upload_ecas_file",
            formData
          );
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     *
     */
    enableEcasDownload: builder.mutation<
      any,
      { id_bl: number; id_usuario: number }
    >({
      queryFn: async ({ id_bl, id_usuario }) => {
        try {
          await new Promise((resolve) => setTimeout(resolve, 500));
          const { data } = await mainApi.post("bls-import/enable_ecas", {
            id_bl,
            id_usuario,
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * Downloads the ecas file
     */
    downloadEcasFile: builder.mutation<
      any,
      {
        id_bl: number;
        id_usuario: number;
        fileName: string;
      }
    >({
      queryFn: async ({ id_bl, id_usuario, fileName }) => {
        try {
          const { data } = await mainApi.get("/bls-import/download_ecas", {
            timeout: 120000,
            params: {
              id_bl,
              id_usuario,
            },
            responseType: "blob",
          });
          donwloadDefaultFile(fileName, data);
          return { data: {} };
        } catch (error: any) {
          alert("No se pudo descargar el archivo");
          console.error(error);
          return { error: error };
        }
      },
    }),
  }),
});

export const {
  useGetBlImportsQuery,
  useLazyGetBlImportsQuery,
  useDownloadBlImportMutation,
  useSearchContainersImportQuery,
  useDownloadBlImportActaMutation,
  useDonwloadXlxsBlsImportMutation,
  useUploadBlImportDocumentMutation,
  useUploadEcasFileMutation,
  useEnableEcasDownloadMutation,
  useDownloadEcasFileMutation,
} = BLImportService;
